import {
  EstateForMandatePageFragment,
  MandateFragment,
  Seller_Type_Enum,
} from '@gql'
import i18next from 'i18next'

const representativeEmptyValue = () =>
  i18next.t('MandateInfoForm.defaultValues.representatives.emptyValue')

export function generateRepresentativesNames(
  availableSellers: {
    id: string
    name: string
    headquarter?: string | null
    address?: string | null
  }[]
): string {
  return availableSellers
    .map(
      ({ name }, index) =>
        `${index + 1}. ${name ?? i18next.t('MandateInfoForm.defaultValues.representatives.emptyValue')}`
    )
    .join('\n')
}

export function generateRepresentativesAddress(
  availableSellers: {
    type?: Seller_Type_Enum | null
    headquarter?: string | null
    address?: string | null
  }[]
): string {
  return availableSellers
    .map(({ type, headquarter, address }, index) => {
      const representativeAddress =
        type === Seller_Type_Enum.LegalEntity
          ? headquarter || address
          : address || headquarter

      return `${index + 1}. ${representativeAddress || representativeEmptyValue()}`
    })
    .join('\n')
}

export function generateObjectLabel(
  mandate: MandateFragment | null | undefined
) {
  return mandate?.type ? i18next.t(`common.mandate.${mandate?.type}`) : ''
}

export function generateEstateLabel(
  estate: Pick<
    EstateForMandatePageFragment,
    'address' | 'type' | 'zipCode' | 'city' | 'seller' | 'id' | 'estate_sellers'
  >
) {
  return i18next.t('MandateInfoForm.defaultValues.estateLabel', {
    type: estate.type ? i18next.t(`common.estate.${estate.type}`) : '',
    address: estate.address,
    zipCode: estate.zipCode,
    city: estate.city,
  })
}
